import {z} from 'zod';

import {jsonValueSchema} from './AdvertisementPayloadSchema';

export const advertisingPlatformCodeSchema = z.string().min(1);

export const advertisingOperationSchema = z.enum(['publish', 'update', 'remove']);

export const advertisingJobStatusSchema = z.enum(['pending', 'running', 'done', 'failed']);

export const advertisingAdapterErrorCodeSchema = z.enum([
  'credentials-invalid',
  'validation-failed',
  'rate-limited',
  'upstream-unavailable',
  'unknown-platform',
  'mapping-failed',
  'unknown',
]);

export const advertisingImageSchema = z.object({
  url: z.string().url(),
  is360: z.boolean().default(false),
});

export const advertisingProgressSchema = z.object({
  stage: z.string(),
  percent: z.number().min(0).max(100),
});

export const advertisingCredentialsSchema = z.record(jsonValueSchema);

export type AdvertisingOperation = z.infer<typeof advertisingOperationSchema>;
export type AdvertisingJobStatus = z.infer<typeof advertisingJobStatusSchema>;
export type AdvertisingAdapterErrorCode = z.infer<typeof advertisingAdapterErrorCodeSchema>;
export type AdvertisingImage = z.infer<typeof advertisingImageSchema>;
export type AdvertisingProgress = z.infer<typeof advertisingProgressSchema>;
